import fetch from '../utils/fetch'

export function searchAPI(data) {
    return fetch({
        url:  '/aboutus/search',
        method: "get",
        params: data,
    })
}
